import React from 'react';
import { withFormik } from 'formik';
import { compose, withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import yup from 'yup';

import TicketForm from './TicketForm';
import { CreatePassengerTicket } from '../../mutations/CreatePassengerTicket';
import { UpdatePassengerTicket } from '../../mutations/UpdatePassengerTicket';

const initialTicketForm = {
  pnr: '',
  token: '',
  passengerLanguage: '',
  passengerFirstName: '',
  passengerLastName: '',
  passengerPhone: '',
  passengerEmail: '',
  affiliateId: '',
  employer: '',
  promoCodeId: '',
  number: ''
};

const ERROR_REQUIRED = 'This field is required';
const ERROR_EMAIL = 'Incorrect email';

const TicketFormContainer = ({
  isSubmitting,
  loading,
  setFieldValue,
  setFieldTouched,
  history,
  ...rest
}) => {
  const handleChange = (e, { name, value }) => setFieldValue(name, value);

  const handleBlur = name => setFieldTouched(name, true);

  const handleCancel = () => history.goBack();

  return (
    <TicketForm
      {...rest}
      onChange={handleChange}
      onCancel={handleCancel}
      onBlur={handleBlur}
      loading={loading || isSubmitting}
    />
  );
};

const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: ({ ticket }) => {
    if (!ticket) return initialTicketForm;

    const {
      pnr,
      token,
      passengerLanguage,
      passengerFirstName,
      passengerLastName,
      passengerPhone,
      passengerEmail,
      affiliate,
      employer,
      promoCode,
      number
    } = ticket;

    return {
      pnr: pnr || '',
      token: token || '',
      passengerLanguage: passengerLanguage || '',
      passengerFirstName: passengerFirstName || '',
      passengerLastName: passengerLastName || '',
      passengerPhone: passengerPhone || '',
      passengerEmail: passengerEmail || '',
      affiliateId: affiliate.id || '',
      employer: employer || '',
      promoCodeId: promoCode ? promoCode.id : '',
      number: number || ''
    };
  },
  validationSchema: () => {
    return yup.object().shape({
      passengerLanguage: yup.string().required(ERROR_REQUIRED),
      passengerFirstName: yup.string().required(ERROR_REQUIRED),
      passengerLastName: yup.string().required(ERROR_REQUIRED),
      passengerPhone: yup.string().required(ERROR_REQUIRED),
      passengerEmail: yup
        .string()
        .email(ERROR_EMAIL)
        .required(ERROR_REQUIRED),
      affiliateId: yup.string().required(ERROR_REQUIRED),
      employer: yup.string().required(ERROR_REQUIRED),
      number: yup.string().required(ERROR_REQUIRED)
    });
  },
  handleSubmit: (values, { props, setErrors, setSubmitting }) => {
    const input = { ...values };
    if (props.edit) {
      props.client
        .mutate({
          mutation: UpdatePassengerTicket,
          variables: {
            input: {
              ticket: {
                ...input,
                id: props.match.params.id
              }
            }
          }
        })
        .then(({ data }) => {
          setErrors({});
          setSubmitting(false);
          props.history.goBack();
        })
        .catch(error => {
          setErrors({ serverError: error });
          setSubmitting(false);
          window.scrollTo(0, 0);
        });
    } else {
      props.client
        .mutate({
          mutation: CreatePassengerTicket,
          variables: {
            input
          }
        })
        .then(({ data }) => {
          setErrors({});
          setSubmitting(false);
          props.history.goBack();
        })
        .catch(error => {
          const errorMsg = error.message;
          setErrors({ serverError: errorMsg });
          setSubmitting(false);
          window.scrollTo(0, 0);
        });
    }
  }
};

export default compose(
  withApollo,
  withRouter,
  withFormik(formikConfig)
)(TicketFormContainer);



// WEBPACK FOOTER //
// ./src/component/TicketFormPage/TicketFormContainer.js